import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";
import auth from "./auth.module";
import htmlClass from "./htmlclass.module";
import config from "./config.module";
import breadcrumbs from "./breadcrumbs.module";
import profile from "./profile.module";
import subscribers from "./subscribers";
import accounts from "./accounts";
import campaigns from "./campaigns";
import locations from "./locations";
import dashboard from "./dashboard";
import customers from "./customers";
import local_performance_marketing from "./local_performance_marketing";

Vue.use(Vuex);

export default new Vuex.Store({
  plugins: [],
  modules: {
    auth,
    htmlClass,
    config,
    breadcrumbs,
    profile,
    subscribers,
    accounts,
    campaigns,
    locations,
    dashboard,
    customers,
    local_performance_marketing
  }
});
